import React, { useState } from 'react';
import './StallBookingBehavior.scss';
import Card from '@material-ui/core/Card';
import dummyImage from "../../../assets/images/dummy.png";
import { FxCurrency, FxPopup } from '../../fx-core';
import { Button, Dialog, Drawer, makeStyles } from '@material-ui/core';
import info from "../../../assets/info.png";
import ImageSlides from '../../general/ImageSlides/ImageSlides';
import { useSelector } from 'react-redux';
import LoginContainer from '../../LoginContainer/LoginContainer';

const styles = makeStyles((theme) => ({
  drawerWidth: {
    [theme.breakpoints.down(599)]: { width: '90%' },
    [theme.breakpoints.up(600)]: { width: '70%' },
    [theme.breakpoints.up(1025)]: { width: '40%' }
  }
}));

const StallBookingBehavior = (props: any) => {
  const classes = styles();
  const login = useSelector<any, any>(s => s.login);

  const [imageSlideOpen, setImageSlideOpen] = useState(false);
  const [imageConfig, setImageConfig] = useState({});
  const [openLogin, setOpenLogin] = useState(false);

  const openImages = (item: any) => {
    let config = {
      api: `portal/stallbooking/${item.id}/images`,
      title: item.title
    };
    setImageConfig(config);
    setImageSlideOpen(true);
  };

  const handleImageSlideClose = () => setImageSlideOpen(false);
const noopEvent: any = {
  stopPropagation: () => {},
  preventDefault: () => {}
};
  // exactly like StallBookingEntry: open login drawer if not logged in
  const handleBookNow = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!login?.isLogin) {
      setOpenLogin(true);
      return;
    }
    // already logged in → proceed to entry page
    props.navToBookingEntry(e, props.item.id);
  };

  const handleLoginClose = () => setOpenLogin(false);

  // after successful login from drawer, close and continue to booking entry
  const onLoginCallBack = () => {
    handleLoginClose();
    // mirror the setTimeout pattern you used in StallBookingEntry
    setTimeout(() => {
      // now proceed to booking entry for this item
      props.navToBookingEntry(noopEvent, props.item.id);
    }, 0);
  };

 return (
  <div className="bookingservice-ui">
    {/* Desktop View */}
    <div className="deskview pt-5">
      <Card style={{ width: "350px", height: "auto" }} className="d-flex flex-column px-2 py-3 pointer">
        <div className="row justify-content-center pointer" onClick={() => openImages(props.item)}>
          {!props.item.imageUrl && <img src={dummyImage} alt="Item" width="150" height="150" className="itemimage" />}
          {props.item.imageUrl && <img src={props.item.imageUrl} alt="Item" width="150" height="150" className="itemimage" />}
        </div>

        <div className='mt-3 text-center'>
          <span className="font-22 itemname-style">{props.item.name}</span>
          {
            props.item.description &&
            <span className='info-placement pl-2 zoom-in-out-box'>
              <FxPopup image={info} popupId={`booking-${props.item.id}`} maxWidth="370px" fontSize="12px">
                <div className='p-3 card-style'>
                  <span>{props.item.description}</span>
                </div>
              </FxPopup>
            </span>
          }
        </div>

        <div className='mt-3'>
          {/* Total Time */}
          <div className='mb-2'>
            <span className='bold-text'>Total Time: </span>
            <span>
              {props.item.durationInMins} {
                props.item.deliveryTimeUnits === 1 ? 'Minutes' :
                props.item.deliveryTimeUnits === 2 ? 'Hours' :
                props.item.deliveryTimeUnits === 3 ? 'Days' :
                'Minutes'
              }
            </span>
          </div>

          {/* Price */}
          <div className='mb-2'>
            {!props.item.unit && <span className='bold-text'>Price: </span>}
            {props.item.unit && <span className='bold-text'>Price / {props.item.unit}: </span>}
            <span><FxCurrency value={props.item.pricePerSeat} /></span>
          </div>

          {/* Booking Mode */}
          <div className='mb-2'>
            <span className='bold-text'>{props.item.bookingModeId === 1 ? "Booking Venue :" :"Booking Mode :"} </span>
            <span>
              {
                props.item.bookingModeId === 1 ? props.item.venueDetail :
                props.item.bookingModeId === 2 ? 'Online' :
                'N/A'
              }
            </span>
          </div>

          {/* URL (only for Online mode) */}
          {/* {
            props.item.bookingModeId === 2 && props.item.url && (
              <div className='mb-2'>
                <span className='bold-text'>URL: </span>
                <a 
                  href={props.item.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: '#1976d2', textDecoration: 'underline', wordBreak: 'break-all' }}
                >
                  {props.item.url}
                </a>
              </div>
            )
          } */}
        </div>

        <div className='text-center pt-3'>
          <Button color="primary" variant="contained" onClick={handleBookNow}>
            <b>Book Now</b>
          </Button>
        </div>
      </Card>
    </div>

    <Dialog
      open={imageSlideOpen}
      onClose={handleImageSlideClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <ImageSlides imageConfig={imageConfig} handleImageSlideClose={handleImageSlideClose} />
    </Dialog>

    {/* Login Drawer */}
    <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={openLogin} onClose={handleLoginClose}>
      <LoginContainer handleLoginClose={handleLoginClose} onLoginCallBack={onLoginCallBack} />
    </Drawer>
  </div>
);

};

export default StallBookingBehavior;
